import {
  getHighContrastNoAdjustStyle,
  HighContrastSelector,
  IStyle,
  memoizeFunction,
} from "@fluentui/react";

export type InnerBorderSettings = {
  /** width of the inner border */
  width: number | string;

  /** Color of the inner border */
  color: string;

  /** Gap between outer and inner border (or number of pixels inside outer edge if no outer border present) */
  gap?: number | string;

  /** Border style */
  style?:
    | "solid"
    | "dashed"
    | "dotted"
    | "double"
    | "groove"
    | "ridge"
    | "inset"
    | "outset"
    | "hidden"
    | "none";
};

/** Inner border is most easily achieved with :after CSS selector. The selector itself is defined by the caller and this
 * function just returns the styles (IStyle) necessary
 */
export const getInnerBorderStyles: (
  borderSettings: InnerBorderSettings
) => IStyle = memoizeFunction((borderSettings: InnerBorderSettings) => {
  const gap = borderSettings.gap || 0;
  const gapStyles = {
    top: gap,
    left: gap,
    right: gap,
    bottom: gap,
  };

  return {
    content: '""',
    position: "absolute",
    borderWidth: borderSettings.width,
    borderStyle: borderSettings.style || "solid",
    borderColor: borderSettings.color,
    pointerEvents: "none",
    ...gapStyles,
    selectors: {
      [HighContrastSelector]: {
        borderColor: "HighlightText",
        ...getHighContrastNoAdjustStyle(),
      },
    },
  };
});
